/** Panel de depuración: fps, coste de render y estado del jugador. Se muestra con ?debug=1 */
export class DebugHud {
  constructor(el, renderer) {
    this.el = el;
    this.renderer = renderer;
    this.enabled = new URLSearchParams(location.search).get('debug') === '1';
    this.el.hidden = !this.enabled;
    this.frames = 0;
    this.elapsed = 0;
    this.worst = 0;
    this.stats = { fps: 0, worstMs: 0, cpuMs: 0 };
    this.cpu = 0;
  }

  update(dt, game, cpuMs = 0) {
    this.frames++;
    this.cpu += cpuMs;
    this.elapsed += dt;
    this.worst = Math.max(this.worst, dt);
    if (this.elapsed < 0.5) return;
    this.stats.fps = Math.round(this.frames / this.elapsed);
    this.stats.worstMs = Math.round(this.worst * 1000);
    this.stats.cpuMs = +(this.cpu / this.frames).toFixed(2);
    this.cpu = 0;
    this.frames = 0;
    this.elapsed = 0;
    this.worst = 0;
    if (!this.enabled) return;

    const info = this.renderer.info.render;
    const p = game.player;
    const path = game.world.path;
    const u = path.usage();
    this.el.textContent = [
      `fps ${this.stats.fps}  peor ${this.stats.worstMs} ms  cpu ${this.stats.cpuMs} ms  calidad ${game.quality.label}`,
      `draw ${info.calls}  tris ${info.triangles}`,
      `juego ${game.state}  jugador ${p.state}  semilla ${game.world.seed}`,
      `tramo ${p.segment.depth}  s ${p.s.toFixed(1)}  carril ${p.lane}  v ${p.speed.toFixed(1)}`,
      `tramos ${path.live.length}  obst ${u.low + u.high + u.wall}  monedas ${u.coin}  árboles ${u.canopy}  suelo ${u.floor}`,
      `${p.sliding ? 'deslizando ' : ''}${p.queuedTurn ? 'giro en cola' : ''}`,
      ...(game.cam?.running ? [this.#camera(game.cam)] : []),
    ].join('\n');
  }

  /** Cámara: motor, inferencias/s y latencia de la captura al gesto (objetivo < 150 ms). */
  #camera(cam) {
    const s = cam.stats;
    const last = s.last ? `  último ${s.last.type} ${Math.round(s.last.latency)} ms` : '';
    const gesture = s.gestureMs === null ? '-' : `${Math.round(s.gestureMs)} ms`;
    return (
      `cámara ${s.backend}  ${s.fps.toFixed(0)} inf/s  inferencia ${s.inferMs.toFixed(0)} ms  captura→pose ${Math.round(s.pipelineMs)} ms\n` +
      `captura→gesto media ${gesture}${last}`
    );
  }
}
